import { useEffect, useMemo } from "react"
import styled from "styled-components"

import { useLazyGetMobileUsageWidgetQuery } from "store/api/clientApi"

import { Spinner } from "components/common/Spinner"

const WidgetWrapper = styled.div`
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 0 32px 20px;
  flex: 1 1 calc(50% - 10px);
  max-width: calc(50% - 10px);
  min-width: 0;
  min-height: 173px;
  position: relative;

  @media only screen and (max-width: 900px) {
    flex: 1 1 100%;
    max-width: 100%;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

const WidgetHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #f1f5f9;
`

const Title = styled.h3`
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`

const WidgetLoader = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  margin: 20px 0 6px;
  border-right: 1px solid #f1f5f9;

  &:last-child {
    border-right: none;
  }

  h4 {
    font-size: 12px;
    color: #64748b;
    margin: 0 0 8px 0;
  }

  span {
    font-size: 24px;
    font-weight: 500;
    color: #0f172a;
  }
`

export const WidgetCustomersMobileUsage = () => {
  const [triggerGetMobileUsageWidget, { isFetching, data }] = useLazyGetMobileUsageWidgetQuery()

  useEffect(() => {
    const fetchData = async () => {
      try {
        await triggerGetMobileUsageWidget()
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [triggerGetMobileUsageWidget])

  const contentData = useMemo(() => {
    if (!data?.data) return []

    const widgetData = data.data

    return [
      {
        title: "Total Customers",
        value: widgetData.customers,
      },
      {
        title: "With Mobile app",
        value: widgetData.mobile_app_activated,
      },
      {
        title: "Without Mobile app",
        value: widgetData.customers - widgetData.mobile_app_activated,
      },
    ]
  }, [data])

  return (
    <WidgetWrapper>
      <WidgetHeader>
        <Title>Customers & Mobiles app usage</Title>
      </WidgetHeader>
      {isFetching && (
        <WidgetLoader>
          <Spinner />
        </WidgetLoader>
      )}
      <Container>
        {contentData.map(({ title, value }) => (
          <Item key={title}>
            <h4>{title}</h4>
            <span>{value}</span>
          </Item>
        ))}
      </Container>
    </WidgetWrapper>
  )
}
